// Why the API refused to use a membership or package on a booking, in the reader's language.
export const MANAGEMENT_ENTITLEMENT_ERROR_KEYS = {
  MembershipEntitlementRequiresAllServices: 'customer.appointments.booking.entitlementErrors.membershipRequiresAllServices',
  MembershipEntitlementExceeded: 'customer.appointments.booking.entitlementErrors.membershipExceeded',
  ServicePackageEntitlementNotApplicable: 'customer.appointments.booking.entitlementErrors.packageRequiresAllServices',
  ServicePackageEntitlementExhausted: 'customer.appointments.booking.entitlementErrors.packageExhausted',
  ServicePackageExpired: 'customer.appointments.booking.entitlementErrors.packageExpired',
  ServicePackageTeamMemberNotAllowed: 'customer.appointments.booking.entitlementErrors.packageProfessional',
  CustomerServicePackageNotEligible: 'customer.appointments.booking.entitlementErrors.packageNotUsable',
  AppointmentEntitlementConflict: 'customer.appointments.booking.entitlementErrors.conflict',
  FreeServiceUsageLimitExceeded: 'managementAppointments.book.freeServiceUsageExceeded',
};
